/**
 * Generated bundle index. Do not edit.
 */

export {QuickMessage,QuickMessageModule} from './index';
